"use client"

import { useCallback, useEffect, useState } from "react"

import {
  POSTHOG_CONSENT_CHANGE_EVENT,
  PostHogConsentStatus,
  getPostHogConsentFromDocument,
  setPostHogConsent,
} from "@/lib/posthog-consent"

type UsePostHogConsentReturn = {
  consent: PostHogConsentStatus | null
  hasExplicitChoice: boolean
  isTrackingEnabled: boolean
  isMounted: boolean
  updateConsent: (consent: PostHogConsentStatus) => void
}

export default function usePostHogConsent(): UsePostHogConsentReturn {
  const [consent, setConsent] = useState<PostHogConsentStatus | null>(null)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    const syncConsent = () => {
      setConsent(getPostHogConsentFromDocument())
      setIsMounted(true)
    }

    syncConsent()
    window.addEventListener(POSTHOG_CONSENT_CHANGE_EVENT, syncConsent)

    return () => {
      window.removeEventListener(POSTHOG_CONSENT_CHANGE_EVENT, syncConsent)
    }
  }, [])

  const updateConsent = useCallback((nextConsent: PostHogConsentStatus) => {
    setPostHogConsent(nextConsent)
    setConsent(nextConsent)
    setIsMounted(true)
  }, [])

  return {
    consent,
    hasExplicitChoice: consent !== null,
    isTrackingEnabled: consent !== "denied",
    isMounted,
    updateConsent,
  }
}
